import { strCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import { fromNullable } from 'data.maybe'

export const modifiedDateGetter = ({ rowData }) =>
  rowData && rowData.modificationInfo
    ? rowData.modificationInfo.modDate
    : undefined

export const modifierGetter = ({ rowData }) =>
  rowData && rowData.modificationInfo ? rowData.modificationInfo.user : ''

const submitStatusGetter = ({ rowData }) => {
  const status =
    rowData && rowData.submitInfo ? rowData.submitInfo.submitStatus : undefined
  return status === '0'
    ? 'To Be Submitted'
    : status === '1'
    ? 'Failed To Send'
    : status === '2'
    ? 'Validated'
    : status === '3'
    ? 'Invalidated'
    : status === '4'
    ? ' Accepted'
    : status
}

const submitTransIdGetter = ({ rowData }) =>
  rowData && rowData.submitInfo ? rowData.submitInfo.submitTransId : undefined

const submissionMsgGetter = ({ rowData }) =>
  rowData && rowData.submitInfo ? rowData.submitInfo.submissionMsg : undefined

const submissionTimeGetter = ({ rowData }) =>
  rowData && rowData.submitInfo ? rowData.submitInfo.submissionTime : undefined

export const modifierCol = {
  ident: 'modifier',
  display: 'Modifier',
  dataGetter: modifierGetter,
  showInRowEditor: false,
  type: 'str',
  width: 130,
  isKey: true,
}

// const defaultPropsForHeaders = {
//   editable: true,
//   isKey: false,
//   alignment: 'center',
//   width: 100,
//   sortable: true,
//   showInRowEditor: true,
// }

export const modifiedDateCol = {
  ident: 'modifiedDate',
  display: 'Modified Date',
  dataGetter: modifiedDateGetter,
  width: 200,
  showInRowEditor: false,
  dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
  displayFormat: 'MM/DD/YYYY HH:mm:SS',
  type: 'date-time',
  isKey: true,
}

export const yesNoBoolColumnProps = {
  choices: [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' },
  ],
  dataFormatter: ({ value }) =>
    typeof value === 'string' &&
    (value.toLowerCase() === 'true' || value.toLowerCase() === 'y')
      ? 'Yes'
      : value == null
      ? ''
      : value
      ? 'Yes'
      : 'No',
}

export const submitStatusCol = strCol({
  ident: 'submitStatus',
  display: 'Submission Status',
  dataGetter: submitStatusGetter,
  showInRowEditor: false,
  width: '125',
})

export const submitTransIdCol = strCol({
  ident: 'submitTransId',
  display: 'Submit Trans Id',
  dataGetter: submitTransIdGetter,
  showInRowEditor: false,
  width: '125',
})

export const submissionMsgCol = strCol({
  ident: 'submissionMsg',
  display: 'Submission Message',
  dataGetter: submissionMsgGetter,
  showInRowEditor: false,
  width: '225',
})

export const submissionTimeCol = dateTimeCol({
  ident: 'submissionTime',
  display: 'submission Time',
  dataGetter: submissionTimeGetter,
  width: 200,
  showInRowEditor: false,
  dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
  displayFormat: 'MM/DD/YYYY HH:mm:SS.sss',
})

export const withSubmissionRenderer = baseRenderer => props => {
  const { rowIndex, data } = props
  const rowData = data[rowIndex]
  const status =
    rowData && rowData.submitInfo ? rowData.submitInfo.submitStatus : undefined
  return fromNullable(status)
    .map(status => {
      const customProps =
        status === '2' || status === '4'
          ? {}
          : status === '1' || status === '3'
          ? { backgroundColor: 'rgba(255,0,0,.13)' }
          : { backgroundColor: 'rgba(220,220,0,.35)' }
      return baseRenderer({ ...props, ...customProps })
    })
    .orElse(() => fromNullable(baseRenderer(props)))
    .get()
}

export const retiredTypes = {
  0: 'No',
  1: 'Yes',
}

export const YNBooleanTypes = {
  Y: 'Yes',
  N: 'No',
}

export const utilityHeader = strCol({
  ident: 'utility',
  display: 'Utility',
  width: 350,
  isKey: true,
  sortOrder: 'asc',
  ellipsis: true,
})

export const utilityReqHeader = strCol({
  ident: 'utility',
  display: 'Utility',
  width: 450,
  isRequired: true,
  sortOrder: 'asc',
  ellipsis: true,
})

export const unitHeader = strCol({
  ident: 'unit',
  display: 'Unit',
  width: 450,
  isKey: true,
  sortOrder: 'asc',
  ellipsis: true,
})

export const unitIdHeader = strCol({
  ident: 'unitId',
  display: 'Unit',
  width: 350,
  isKey: true,
  sortOrder: 'asc',
  ellipsis: true,
})
